import { Suspense } from 'react';
import ImpersonationBar from './ImpersonationBar/ImpersonationBar';
import LogoutBar from './LogoutBar/LogoutBar';
import MainHeaderBar from './MainHeaderBar/MainHeaderBar';
import NavBar from './NavBar/NavBar';
import styles from './Header.module.scss';
 
export default function Header() {
    return(
        <header className={styles.headerContainer}> 
            <ImpersonationBar />
            <LogoutBar />
            <Suspense>
                <MainHeaderBar />
            </Suspense>
            <NavBar />
        </header>
    );
}